const babelConfigContent = `module.exports = {
  presets: ["@vue/cli-plugin-babel/preset"]
};
`;

export default babelConfigContent;
